"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtiIntegrationOneTrustService = void 0;
var pub_sub_service_1 = require("./pub-sub.service");
var OtiIntegrationOneTrustService = /** @class */ (function () {
    function OtiIntegrationOneTrustService(logService) {
        this.logService = logService;
        this.otLocalStorage = false;
        this.cookiePreferenceChange$ = new pub_sub_service_1.PubSubService();
    }
    OtiIntegrationOneTrustService.prototype._isOptanonInitiallyLoad = function () {
        return !this._getOTDataLayer().some(function (item) { return item.event === 'trackOptanonEvent'; });
    };
    OtiIntegrationOneTrustService.prototype._getOTApplicableKey = function () {
        var key = this.otKey || '';
        if (!this.isOnProduction) {
            key += '-test';
        }
        return key;
    };
    OtiIntegrationOneTrustService.prototype._getCookiesActiveGroups = function () {
        var prev = null;
        var next = null;
        var dataLayer = this._getOTDataLayer();
        /* dataLayer is the one which gets updated with the latest categories whenever
        we make any changes to the cookie categories from OneTrust preference center */
        var groupsUpdated = dataLayer.filter(function (item) { return item.event === 'OneTrustLoaded'; });
        if (groupsUpdated.length > 1) {
            prev = groupsUpdated[groupsUpdated.length - 2].OnetrustActiveGroups.split(',');
            next = groupsUpdated[groupsUpdated.length - 1].OnetrustActiveGroups.split(',');
        }
        else if (groupsUpdated.length === 1) {
            next = groupsUpdated[groupsUpdated.length - 1].OnetrustActiveGroups.split(',');
        }
        return { prev: prev, next: next };
    };
    OtiIntegrationOneTrustService.prototype._getCurrentActiveCookiesGroup = function () {
        return this._getCookiesActiveGroups().next;
    };
    OtiIntegrationOneTrustService.prototype._getPreviousActiveCookiesGroup = function () {
        return this._getCookiesActiveGroups().prev;
    };
    OtiIntegrationOneTrustService.prototype._getOTDataLayer = function () {
        var dataLayer = window.dataLayer;
        if (!dataLayer) {
            throw new Error('OneTrust library is not loaded');
        }
        return dataLayer;
    };
    OtiIntegrationOneTrustService.prototype._getOTLibrary = function () {
        return window.OneTrust;
    };
    OtiIntegrationOneTrustService.prototype.configure = function (_a) {
        var options = _a.options, isOnProduction = _a.isOnProduction;
        this.isOnProduction = isOnProduction;
        this.otKey = options.ot_key;
        this.otLanguage = options.ot_language;
        this.otLocalStorage = options.ot_localStorage === true;
    };
    OtiIntegrationOneTrustService.prototype.enabled = function () {
        return !!this.otKey;
    };
    OtiIntegrationOneTrustService.prototype.init = function () {
        var _this = this;
        // make sure to create OptanonWrapper before load One Trust scripts
        window.OptanonWrapper = function () {
            _this.onCookiePreferencesChanges();
        };
        this.logService.log('OneTrust initialized');
        var cookieBannerId = this._getOTApplicableKey();
        this.logService.log('OT Key=', cookieBannerId);
        var script1 = document.createElement('script');
        script1.setAttribute('type', 'text/javascript');
        script1.setAttribute('src', "https://cdn.cookielaw.org/consent/".concat(cookieBannerId, "/OtAutoBlock.js"));
        var script2 = document.createElement('script');
        script2.setAttribute('type', 'text/javascript');
        script2.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
        if (this.otLocalStorage) {
            script2.setAttribute('amp', 'true');
        }
        if (this.otLanguage) {
            script2.setAttribute('data-language', this.otLanguage);
        }
        script2.setAttribute('charset', 'UTF-8');
        script2.setAttribute('data-domain-script', cookieBannerId);
        var header = document.getElementsByTagName('head')[0];
        if (header) {
            header.appendChild(script1);
            header.appendChild(script2);
        }
    };
    OtiIntegrationOneTrustService.prototype.onCookiePreferencesChanges = function () {
        if (this._isOptanonInitiallyLoad()) {
            var nextActiveGroups = this._getCurrentActiveCookiesGroup();
            if (!nextActiveGroups) {
                this.logService.log('Missing CookiesPreference');
            }
            else {
                this.cookiePreferenceChange$.publish({ initial: true, next: nextActiveGroups });
            }
        }
        else {
            var nextActiveGroups = this._getCurrentActiveCookiesGroup();
            var prevActiveGroups = this._getPreviousActiveCookiesGroup();
            if (!nextActiveGroups || !prevActiveGroups) {
                this.logService.log('Missing CookiesPreference');
            }
            else {
                this.cookiePreferenceChange$.publish({ initial: false, next: nextActiveGroups, prev: prevActiveGroups });
            }
        }
    };
    OtiIntegrationOneTrustService.prototype.openCookiePreferences = function () {
        var otLibrary = this._getOTLibrary();
        if (otLibrary) {
            otLibrary.ToggleInfoDisplay();
        }
    };
    OtiIntegrationOneTrustService.prototype.printDebug = function () {
        var otStorage = localStorage.getItem(this._getOTApplicableKey());
        if (!otStorage) {
            console.warn('Unable to get user preferences');
        }
        else {
            var otStorageObj = JSON.parse(otStorage);
            var otPreferences = {};
            otStorageObj.OptanonConsent.split('&').reduce(function (obj, data) {
                var dataArray = data.split('=');
                if (dataArray.length >= 2) {
                    obj[dataArray[0]] = dataArray[1];
                }
                return obj;
            }, otPreferences);
            var otGroups = {};
            decodeURIComponent(otPreferences.groups)
                .split(',')
                .reduce(function (obj, data) {
                var dataArray = data.split(':');
                if (dataArray.length >= 2) {
                    obj[dataArray[0]] = dataArray[1] === '1';
                }
                return obj;
            }, otGroups);
            console.table(otGroups);
        }
    };
    return OtiIntegrationOneTrustService;
}());
exports.OtiIntegrationOneTrustService = OtiIntegrationOneTrustService;
